import styled from "styled-components";

export const BaseContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height:90vh;
`;